"use strict";
(self["webpackChunkshine_on"] = self["webpackChunkshine_on"] || []).push([[771],{

/***/ 1862:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9346);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _vue_components_Articles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7578);



window.PSTheme.Vue.Blog = new (vue__WEBPACK_IMPORTED_MODULE_1___default())({
  name: 'Blog',
  components: {
    Articles: _vue_components_Articles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z
  }
}).$mount('.articles');

/***/ }),

/***/ 7578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Articles; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Articles.vue?vue&type=template&id=bc448500&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"more-posts--wrapper"},_vm._l((_vm.articles),function(article,idx){return _c('div',{key:idx,staticClass:"more-posts__block"},[_c('small',{staticClass:"more-posts__block-date"},[_c('strong',{domProps:{"innerHTML":_vm._s(article.date)}}),_vm._v("\n\t\t\t\t\t/// By "+_vm._s(article.author)+"\n\t\t\t\t")]),_vm._v(" "),_c('h5',[_c('a',{attrs:{"href":article.url}},[_vm._v("\n            "+_vm._s(article.title)+"\n          ")])]),_vm._v(" "),_c('a',{staticClass:"more-posts__block-continue btn--small",attrs:{"href":article.url}},[_vm._v("\n\t\t\t\t\tread\n\t\t\t\t")])])}),0),_vm._v(" "),(_vm.articles.length !== (_vm.articles_count - 3) && _vm.start_page != 1)?_c('button',{staticClass:"more-posts__load btn",on:{"click":function($event){return _vm.loadMore()}}},[_vm._v("\n      Load more\n    ")]):_vm._e()])}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Articles.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Articlesvue_type_script_lang_js_ = ({
  name: 'Articles',
  props: ['url', 'articles_count', 'start_page'],

  data() {
    return {
      page: this.start_page || 2,
      articles: []
    };
  },

  methods: {
    loadMore() {
      fetch(`${this.url}?page=${this.page}&view=articles`).then(res => res.json()).then(data => {
        this.page++;
        this.articles.push(...data);
      });
    }

  },

  mounted() {
    this.loadMore();
  }

});
;// CONCATENATED MODULE: ./src/scripts/vue/components/Articles.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Articlesvue_type_script_lang_js_ = (Articlesvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/Articles.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_Articlesvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Articles = (component.exports);

/***/ }),

/***/ 1900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ normalizeComponent; }
/* harmony export */ });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [346], function() { return __webpack_exec__(1862); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);